<template>
	<div>
		<Layout :back="'/'" class="bg-primary " :navTransparent="true">
			<template slot="header">
				<h1>Reestablecer contraseña</h1>
			</template>

			<div class="main-container p-4">
				<div v-if="!sended">
					<FormulateForm ref="form" name="reset" v-model="form" @submit="save">
						<FormulateInput type="password" name="password" label="Elige una nueva contraseña" validation="between:6,20,length" error-behavior="live" />

						<FormulateInput label="Confirmar contraseña" type="password" name="password_confirm" validation="required|confirm" validation-name="Contraseña" />
					</FormulateForm>
				</div>
			</div>
			<template slot="footer" v-if="!sended">
				<div class="w-100 p-2">
					<div class="btn btn-primary btn-lg btn-block" v-ripple @click="$formulate.submit('reset')">
						<span v-if="saving">Reseteando<i class="icon-loading"></i></span>
						<span v-else>Reestablecer</span>
					</div>
				</div>
			</template>
		</Layout>
	</div>
</template>
<script>
import gql from 'graphql-tag'
import Layout from '@/components/layout/Layout'

export default {
	name: 'ForgotPasswordReset',
	components: {
		Layout,
	},
	data() {
		return {
			code: null,
			form: {
				password: null,
				password_confirm: null,
			},
			sended: false,
			saving: false,
		}
	},
	beforeMount() {
		if (this.$route.params.code) {
			this.code = this.$route.params.code
		} else {
			this.$router.push('/')
		}
	},
	methods: {
		save() {
			this.saving = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($code: String!, $password: String!, $passwordConfirm: String!) {
							sellerPasswordReset(code: $code, password: $password, passwordConfirm: $passwordConfirm)
						}
					`,
					variables: {
						code: this.code,
						password: this.form.password,
						passwordConfirm: this.form.password_confirm,
					},
				})
				.then(({ data }) => {
					this.saving = false
					this.$toast.success('Contraseña reestablecida correctamente')
					// this.$router.push('/login')
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		},
	},
}
</script>

<style scoped>
h1 {
	font-size: 22pt;
	color: #fff;
}
.main-container {
	background-color: #fff;
	border-radius: 24px 0px 0px 0px;
}
</style>
